import { LinearProgress } from "@mui/material";
import { useUiStore } from "../store/uiStore.js";

// Barra di avanzamento globale: visibile quando ci sono chiamate API in corso.
export function GlobalLoader() {
  const pending = useUiStore((s) => s.pending);
  if (pending <= 0) return null;
  return (
    <LinearProgress
      color="primary"
      sx={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 2100, height: 3 }}
    />
  );
}
